export default __webpack_public_path__ + "static/media/001.990d0874.jpg";